import React from 'react';
import './index.css';

class EmployeeDepartmentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attritionData: [{
                retentionTips: "One on one coaching",
                employeeName: ['ahgadjknawdjkandjkawbdkjawbdkawbdkjawk','bajkndwab awdnawkbdawbkdan', 'cjsnjdakwd adawdbawdbakkwd']
            },{
                retentionTips: "Change of Department",
                employeeName: ['d','e', 'f']
            },{
                retentionTips: "Learning & development",
                employeeName: ['g','h', 'i']
            }]
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="d-flex flex-row justify-content-center" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                    {
                        this.props.headings.map(
                            (data, i) => {
                                return <div key={i} className={`${data.headingColor} col-3 text-white mr-1 text-left py-2 `}>
                                    <p className="mb-0 font-weight-bold">{data.headingName}</p>
                                </div>
                            }
                        )
                    }
                </div>
                <div className="customScrollBar" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                    {
                        this.props.attritionData.map(
                            (data, key) => {
                                return <div key={key} className="d-flex flex-row flex-wrap justify-content-center">

                                    <div style={{ backgroundColor: (this.props.Tooltip === true && key === this.props.selected_route_parameter) ? '#E4D342' : key % 2 == 0 ? ' #E7E5E7' : '#F3F1F3', wordWrap: 'break-word' }} className="col-3 align-items-center  mr-1 mt-1 text-center py-1 px-3">
                                        {
                                            data.employeeName.map((ob, i) => {
                                                return (
                                                    <p key={i} className="mb-0 font-weight-bold text-left" style={{fontSize: 12}}>{ob}</p>
                                                )
                                            })
                                        }
                                        {
                                            // Array.isArray(data.employeeName) &&
                                                data.employeeName.length === 0 ?
                                                    <p className="mb-0 font-weight-bold text-left" style={{fontSize: 12}}>No Employees Found</p>
                                                :
                                                    null
                                        }
                                    </div>
                                    {/* <div style={{ backgroundColor: (this.props.Tooltip === true && key === this.props.selected_route_parameter) ? '#E4D342' : key % 2 == 0 ? ' #E7E5E7' : '#F3F1F3' }} className="col-3  ml-1 mt-1 text-left py-1">
                                        <small className="mb-0 ">{data.department}</small>
                                    </div> */}
                                    {
                                        data.retentionTips &&
                                        <div id={`AttritionTarget${key}`} style={{ backgroundColor: (this.props.Tooltip === true && key === this.props.selected_route_parameter) ? '#E4D342' : key % 2 == 0 ? ' #E7E5E7' : '#F3F1F3' }} className="col-3 d-flex flex-row justify-content-between align-items-start mr-1 mt-1 text-left py-1">
                                            <small className="mb-0 font-weight-bold" style={{fontSize: 12}}>{data.retentionTips}</small>
                                            <i onClick={() => { this.props.onClickEmployee(key) }} className="fas  fa-caret-right text-right cursor-pointer text-success"></i>
                                        </div>
                                    }
                                </div>
                            }
                        )
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default EmployeeDepartmentTable


// WEBPACK FOOTER //
// ./src/_components/common/EmployeeDepartmentTable/index.js